import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVisa, BasicApiResponseModel, Core2Config } from '../../shared';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { ReviewEligibilityDto } from '../../../../../../models/aggregates/cms/review-rating/review-eligibility-dto.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class ViewReviewEligibilityService extends BaseApiPublicLoginTemplateService<ReviewEligibilityDto, ReviewEligibilityDto, ReviewEligibilityDto> {

    static readonly REVIEW_SUB_PATH = 'fi/fi-item/reviews/review-eligibility/';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + ViewReviewEligibilityService.REVIEW_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + ViewReviewEligibilityService.REVIEW_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
        this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + ViewReviewEligibilityService.REVIEW_SUB_PATH + BaseApiPublicLoginTemplateService.PUBLIC_EP
        this.httpClient = http;
    }

    public postViewReviewEligibilty(dtoObject: ReviewEligibilityDto, visa: ApiVisa): Observable<boolean> {
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.post<boolean>(
          this.apiUrl,
          dtoObject,
          this.getHttpHeader(visa)
        );
      }
}
